// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as App_Modal$DvmAdminFrontendFr from "../../../../../../common/components/App_Modal.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../../../../../common/components/button/App_Button.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../../../common/App_Typography.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Button.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../../../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_Flash_Edit$DvmAdminFrontendFr from "../../../../../../intl/messages/flash/Messages_Flash_Edit.bs.js";
import * as App_UserTypeCheckBox$DvmAdminFrontendFr from "../../../../../../common/components/input/App_UserTypeCheckBox.bs.js";
import * as App_DateInputFormField$DvmAdminFrontendFr from "../../../../../../common/components/input/App_DateInputFormField.bs.js";
import * as Flash_Edit_Fleet_Version_Modal_Api$DvmAdminFrontendFr from "./Flash_Edit_Fleet_Version_Modal_Api.bs.js";
import * as Flash_Edit_Fleet_Version_Single_Form$DvmAdminFrontendFr from "./Flash_Edit_Fleet_Version_Single_Form.bs.js";

function Flash_Edit_Fleet_Version_Single_Modal(Props) {
  var flash = Props.flash;
  var modelVersionID = Props.modelVersionID;
  var version = Props.version;
  var versionName = Props.versionName;
  var startDate = Props.startDate;
  var endDate = Props.endDate;
  var onClose = Props.onClose;
  var onOk = Props.onOk;
  var fetchUpdatedModelsForDropdownAndCumulables = Props.fetchUpdatedModelsForDropdownAndCumulables;
  var match = React.useState(function () {
        return /* NotStarted */0;
      });
  var setSaveResult = match[1];
  var saveResult = match[0];
  var match$1 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDeleteResult = match$1[1];
  var deleteResult = match$1[0];
  var intl = ReactIntl.useIntl();
  var alert = ReactAlert.useAlert();
  var match$2 = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$3 = match$2[0];
  var userManager = match$3.userManager;
  var selectedRole = match$3.selectedRole;
  var form = Flash_Edit_Fleet_Version_Single_Form$DvmAdminFrontendFr.VersionForm.useForm(Flash_Edit_Fleet_Version_Single_Form$DvmAdminFrontendFr.initialInput, {
        flashStartDate: flash.orderStartDate,
        flashEndDate: flash.orderEndDate
      }, (function (output, submissionCallbacks) {
          Flash_Edit_Fleet_Version_Modal_Api$DvmAdminFrontendFr.saveVersion(setSaveResult, userManager, submissionCallbacks, selectedRole, {
                actionID: flash.actionId,
                modelVersionID: modelVersionID,
                oldStartDate: startDate,
                startDate: output.startDate,
                endDate: output.endDate,
                maxBonus: undefined
              });
        }));
  React.useEffect((function () {
          Curry._2(form.updateStartDate, (function (input, startDate) {
                  return {
                          startDate: startDate,
                          startDateAsFlash: input.startDateAsFlash,
                          endDate: input.endDate,
                          endDateAsFlash: input.endDateAsFlash
                        };
                }), startDate);
          if (Belt_Option.isNone(startDate)) {
            Curry._2(form.updateStartDateAsFlash, (function (input, startDateAsFlash) {
                    return {
                            startDate: input.startDate,
                            startDateAsFlash: startDateAsFlash,
                            endDate: input.endDate,
                            endDateAsFlash: input.endDateAsFlash
                          };
                  }), true);
          }
          Curry._2(form.updateEndDate, (function (input, endDate) {
                  return {
                          startDate: input.startDate,
                          startDateAsFlash: input.startDateAsFlash,
                          endDate: endDate,
                          endDateAsFlash: input.endDateAsFlash
                        };
                }), endDate);
          if (Belt_Option.isNone(endDate)) {
            Curry._2(form.updateEndDateAsFlash, (function (input, endDateAsFlash) {
                    return {
                            startDate: input.startDate,
                            startDateAsFlash: input.startDateAsFlash,
                            endDate: input.endDate,
                            endDateAsFlash: endDateAsFlash
                          };
                  }), true);
          }
          
        }), [
        startDate,
        endDate
      ]);
  React.useEffect((function () {
          if (typeof saveResult === "number") {
            saveResult === /* NotStarted */0;
          } else if (saveResult.TAG === /* Ok */0) {
            Utils_Alert$DvmAdminFrontendFr.success(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {}));
            Curry._1(onOk, undefined);
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: saveResult._0
                      }
                    }));
          }
        }), [saveResult]);
  React.useEffect((function () {
          if (typeof deleteResult === "number") {
            deleteResult === /* NotStarted */0;
          } else if (deleteResult.TAG === /* Ok */0) {
            Utils_Alert$DvmAdminFrontendFr.success(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {}));
            Curry._1(fetchUpdatedModelsForDropdownAndCumulables, undefined);
            Curry._1(onOk, undefined);
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: deleteResult._0
                      }
                    }));
          }
        }), [deleteResult]);
  var tmp = {
    label: Messages_Common$DvmAdminFrontendFr.startDate,
    value: form.input.startDate,
    onChange: Curry._1(form.updateStartDate, (function (input, startDate) {
            return {
                    startDate: startDate,
                    startDateAsFlash: input.startDateAsFlash,
                    endDate: input.endDate,
                    endDateAsFlash: input.endDateAsFlash
                  };
          })),
    disabled: form.input.startDateAsFlash,
    onBlur: (function (param) {
        Curry._1(form.blurStartDate, undefined);
      })
  };
  if (form.startDateResult !== undefined) {
    tmp.validationResult = Caml_option.valFromOption(form.startDateResult);
  }
  var tmp$1 = {
    label: Messages_Common$DvmAdminFrontendFr.endDate,
    value: form.input.endDate,
    onChange: Curry._1(form.updateEndDate, (function (input, endDate) {
            return {
                    startDate: input.startDate,
                    startDateAsFlash: input.startDateAsFlash,
                    endDate: endDate,
                    endDateAsFlash: input.endDateAsFlash
                  };
          })),
    disabled: form.input.endDateAsFlash,
    onBlur: (function (param) {
        Curry._1(form.blurEndDate, undefined);
      })
  };
  if (form.endDateResult !== undefined) {
    tmp$1.validationResult = Caml_option.valFromOption(form.endDateResult);
  }
  return React.createElement(App_Modal$DvmAdminFrontendFr.make, {
              open: true,
              onClose: onClose,
              title: intl.formatMessage(Messages_Common$DvmAdminFrontendFr.editDates),
              minWidth: "700px",
              children: React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                    show: App_Types_Result$DvmAdminFrontendFr.isPending(saveResult),
                    children: React.createElement("form", {
                          onSubmit: (function ($$event) {
                              $$event.preventDefault();
                              Curry._1(form.submit, undefined);
                            })
                        }, React.createElement(Core.Grid, {
                              alignItems: "flex-start",
                              children: null,
                              container: true,
                              direction: "column",
                              spacing: 3
                            }, React.createElement(Core.Grid, {
                                  alignItems: "flex-start",
                                  children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                        color: "primary",
                                        children: null,
                                        variant: "bodyBig"
                                      }, React.createElement(Core.Grid, {
                                            children: "" + intl.formatMessage(Messages_Common$DvmAdminFrontendFr.version) + " " + version + "",
                                            item: true
                                          }), React.createElement(Core.Grid, {
                                            children: versionName,
                                            item: true
                                          })),
                                  container: true,
                                  direction: "column",
                                  item: true,
                                  spacing: 1
                                }), React.createElement(Core.Grid, {
                                  children: React.createElement(Core.Grid, {
                                        alignItems: "center",
                                        children: null,
                                        container: true,
                                        spacing: 3
                                      }, React.createElement(Core.Grid, {
                                            children: React.createElement(App_DateInputFormField$DvmAdminFrontendFr.make, tmp),
                                            item: true
                                          }), React.createElement(Core.Grid, {
                                            children: React.createElement(App_UserTypeCheckBox$DvmAdminFrontendFr.make, {
                                                  label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.sameAsFlash),
                                                  checked: form.input.startDateAsFlash,
                                                  onClick: (function (param) {
                                                      Curry._2(form.updateStartDateAsFlash, (function (input, startDateAsFlash) {
                                                              return {
                                                                      startDate: input.startDate,
                                                                      startDateAsFlash: startDateAsFlash,
                                                                      endDate: input.endDate,
                                                                      endDateAsFlash: input.endDateAsFlash
                                                                    };
                                                            }), !form.input.startDateAsFlash);
                                                    })
                                                }),
                                            item: true
                                          })),
                                  item: true
                                }), React.createElement(Core.Grid, {
                                  children: React.createElement(Core.Grid, {
                                        alignItems: "center",
                                        children: null,
                                        container: true,
                                        spacing: 3
                                      }, React.createElement(Core.Grid, {
                                            children: React.createElement(App_DateInputFormField$DvmAdminFrontendFr.make, tmp$1),
                                            item: true
                                          }), React.createElement(Core.Grid, {
                                            children: React.createElement(App_UserTypeCheckBox$DvmAdminFrontendFr.make, {
                                                  label: intl.formatMessage(Messages_Flash_Edit$DvmAdminFrontendFr.sameAsFlash),
                                                  checked: form.input.endDateAsFlash,
                                                  onClick: (function (param) {
                                                      Curry._2(form.updateEndDateAsFlash, (function (input, endDateAsFlash) {
                                                              return {
                                                                      startDate: input.startDate,
                                                                      startDateAsFlash: input.startDateAsFlash,
                                                                      endDate: input.endDate,
                                                                      endDateAsFlash: endDateAsFlash
                                                                    };
                                                            }), !form.input.endDateAsFlash);
                                                    })
                                                }),
                                            item: true
                                          })),
                                  item: true
                                }), React.createElement(Core.Grid, {
                                  children: null,
                                  container: true,
                                  item: true,
                                  justifyContent: "space-between"
                                }, React.createElement(Core.Grid, {
                                      children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                            onClick: (function (param) {
                                                Flash_Edit_Fleet_Version_Modal_Api$DvmAdminFrontendFr.deleteVersion(userManager, setDeleteResult, flash.actionId, selectedRole, {
                                                      hd: {
                                                        actionID: flash.actionId,
                                                        modelVersionID: modelVersionID,
                                                        oldStartDate: undefined,
                                                        startDate: startDate,
                                                        endDate: endDate,
                                                        maxBonus: undefined
                                                      },
                                                      tl: /* [] */0
                                                    });
                                              }),
                                            label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.$$delete),
                                            color: "delete",
                                            size: "medium",
                                            type_: "button"
                                          }),
                                      item: true
                                    }), React.createElement(Core.Grid, {
                                      children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                            label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                            size: "medium",
                                            type_: "submit"
                                          }),
                                      item: true
                                    }))))
                  })
            });
}

var Form;

var Api;

var make = Flash_Edit_Fleet_Version_Single_Modal;

export {
  Form ,
  Api ,
  make ,
}
/* react Not a pure module */
